/* eslint-disable no-console */

import { register } from 'register-service-worker'

let firebaseServiceWorkerPath
let baseUrl = process.env?.BASE_URL

if (process.env.NODE_ENV === 'development') {
  baseUrl = 'http://localhost:8080/'
}

// Service worker por default.  Al ser el primer service worker el default,
// lamentablemente es el que se usa en entornos productivos.
// Queda como mejora a futuro invertir y el default ser el de pruebas.
firebaseServiceWorkerPath = `${baseUrl}firebase-messaging-sw.js`

// Si hay un custom service worker lo usamos en vez del por default
if (process.env?.VUE_APP_FIREBASE_CUSTOM_SERVICEWORKER) {
  firebaseServiceWorkerPath = `${baseUrl}${process.env.VUE_APP_FIREBASE_CUSTOM_SERVICEWORKER}`
}
register(firebaseServiceWorkerPath, {
  error (error) {
    console.error('LumbreDocs: Error during service worker registration:', error)
  }
})
